/** VALIDATION ERROR MESSAGES IN BROADCAST MODULE */
export const VALIDATION_MESSAGES = {
    login: {
        EMAIL: {
            REQUIRED: 'Enter a valid email address',
            INVALID: 'Enter valid email address'
        },
        PASSWORD: {
            REQUIRED: 'Enter a password',
            MINLENGTH: 'Password Length must be at least 10 character',
            INVALID: 'The password doesn’t match the format',
            MATCH: 'The password confirmation doesn’t match'
        }
    },
    broadcast: {
        message: {
            required: 'Enter your broadcast message',
            maxlength: 'Max 750 characters are allowed'
        }
    },
    welcome: {
        message: {
            required: 'Enter your welcome message',
            maxlength: 'Max 750 characters are allowed'
        }
    }
};

export const PORTAL_USER_FORM_FIELD_ERRORS = {
    fields: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        email: '',
        // zipcode: '',
        role: '',
        address: ''
    },
    validationMessages: {
        role: {
            required: 'Select a role'
        },
        firstName: {
            required: 'Enter first name',
            maxlength: 'Must be at most 20 characters',
            pattern: ''
        },
        lastName: {
            required: 'Enter last name',
            maxlength: 'Must be at most 20 characters',
            pattern: ''
        },
        phoneNumber: {
            required: 'Enter a phone number',
            minlength: '',
            maxlength: '',
            pattern: 'Enter a valid phone number'
        },
        email: {
            required: 'Enter a valid email address',
            minlength: 'Must be at least 5 characters',
            maxlength: 'Must be at most 100 characters',
            pattern: 'Enter a valid email address'
        },
        // zipcode: {
        //     pattern: 'Enter a valid zip code'
        // },
        address: {
            required: 'Enter your address',
            maxlength: 'Must be at most 250 characters',
        },
    }
};

export const USERFORM = {
    fields: {
        centerId: 0,
        fname: '',
        lname: '',
        mname: '',
        age: '',
        gender: '',
        phone_no: '',
        landline: '',
        email: '',
        lang: '',
        interests: [],
        client_delivery_method: {},
        privacy_policy: '',
        obtained_user_consent: '',
        consent_obtained_date: '',
        zipcode: '',
        race: '',
        birthdate: '',
        disable: '',
        veteran: '',
        notes: '',
        client_id: '',
        mediCaidId: '',
        mcoEnrollmentDate: '',
        mcoDisEnrollmentDate: '', 
    },
    validationMessages: {
        centerId: {
            required: 'Select a senior center'
        },
        fname: {
            required: 'Enter first name',
            maxlength: 'Must be at most 50 characters',
            pattern: ''
        },
        lname: {
            required: 'Enter last name',
            maxlength: 'Must be at most 50 characters',
            pattern: ''
        },
        mname: {
            maxlength: 'Must be at most 50 characters',
            pattern: ''
        },
        age: {
            required: 'Enter an age',
            pattern: 'Enter a valid age'
        },
        gender: {
            required: 'Select a gender',
            minlength: '',
            maxlength: ''
        },
        phone_no: {
            required: 'Enter a cell phone number',
            minlength: '',
            maxlength: '',
            pattern: 'Enter a valid cell phone number'
        },
        landline: {
            required: 'Enter a landline number',
            minlength: '',
            maxlength: '',
            pattern: 'Enter a valid landline number'
        },
        email: {
            required: 'Enter a valid email address',
            minlength: 'Must be at least 5 characters',
            maxlength: 'Must be at most 100 characters',
            pattern: 'Enter a valid email address'
        },
        lang: {
            required: 'Select a language',
            maxlength: 'Must be at most 30 characters'
        },
        client_delivery_method: {
            required: 'Select at least one option'
        },
        terms_policy: {
            required: 'This information is required'
        },
        user_consent: {
            required: 'This information is required'
        },
        zipcode: {
            pattern: 'Enter a valid zip code'
        },
        race: {
            pattern: 'Select a valid race/ethnicity'
        },
        birthdate: {
            pattern: 'Enter a valid date of birth'
        },
        disable: {
            pattern: 'Select a valid disability'
        },
        veteran: {
            pattern: 'Select a valid veteran'
        },
        notes: {
            required: 'Enter your notes'
        },
        client_id: {
            maxlength: 'Must be at most 50 characters',
            pattern: 'Enter a valid Org Client ID'
        },
        mediCaidId: {
            required: 'Enter your Medicaid ID'
        },
        mcoEnrollmentDate: {
            matDatepickerParse: 'Enter a valid MCO Enrollment Date',
        },
        mcoDisEnrollmentDate: {
            matDatepickerParse: 'Enter a valid MCO Disenrollment Date',
        }, 
    }
};

export const PROGRAM_FORM = {
    fields: {
        active: '',
        senior_center_id: '',
        name: '',
        event_info: '',
        recurring: '',
        interest_id: '',
        event_start_date: '',
        event_end_date: '',
        event_start_time: '',
        event_end_time: '',
        rec_frequency: '',
        cost: '',
        lang: '',
        type: ''
    },
    validationMessages: {
        active: {
            required: 'Select an active'
        },
        senior_center_id: {
            required: 'Select a senior center'
        },
        name: {
            required: 'Enter event name',
            maxlength: 'Must be at most 200 characters',
            pattern: ''
        },
        event_info: {
            required: 'Enter event information',
            maxlength: 'Must be at most 400 characters',
            pattern: ''
        },
        recurring: {
            required: 'Select a recurring',
        },
        interest_id: {
            required: 'Select an interest',
        },
        event_start_date: {
            required: 'Select a event start date',
        },
        event_end_date: {
            required: 'Select a event end date',
            inappropriate: 'End date should be greater than start date'
        },
        event_start_time: {
            required: 'Select a event start time',
        },
        event_end_time: {
            required: 'Select a event end time',
            inappropriate: 'End time should be greater than start time'
        },
        rec_frequency: {
            required: 'Enter an event frequency',
        },
        cost: {
            required: 'Enter a cost',
        },
        lang: {
            required: 'Select a language',
        },
        type: {
            required: 'Select a event Type',
        }
    }
}


export const SURVEY_FORM = {
        fields: {
            active: '',
            senior_center_id: '',
            name: '',
            description: ''
        },
        validationMessages: {
            active: {
                required: 'Select an active'
            },
            senior_center_id: {
                required: 'Select a Program'
            },
            name: {
                required: 'Enter survey name',
                maxlength: 'Must be at most 60 characters',
                pattern: ''
            },
            description: {
                required: 'Enter survey information',
                maxlength: 'Must be at most 400 characters',
                pattern: ''
            }
        },
        surveyWelcomeMsg: {
            required: 'Enter an Introductory message',
            minlength: 'Must be at least 1 characters',
            maxlength: 'Must be at most 500 characters',
        },
        surveyEndMsg: {
            required: 'Enter an Ending message',
            minlength: 'Must be at least 1 characters',
            maxlength: 'Must be at most 500 characters',
        },
        surveyQuestion: {
            required: 'Enter a question',
            minlength: 'Must be at least 1 characters',
            maxlength: 'Must be at most 500 characters',
        },
        acceptableAns: {
            required: 'Enter an answer',
            maxlength: 'Must be at most 10 answers',
            pattern: 'Enter an valid answer',
        },
        surveyQuestionOption: {
            required: 'Enter an option',
            minlength: 'Must be at least 1 characters',
            maxlength: 'Must be at most 50 characters',
        },
    };
    
export const REFERRAL_CONTACT_FORM = {
    fields: { 
        fname: '', 
        lname: '', 
        job_title: '', 
        phone: '', 
        email: '', 
        zip: ''
    },
    validationMessages: {
        fname: {
            required: 'Enter first name', 
            maxlength: 'Must be at most 30 characters'
        },
        lname: {
            required: 'Enter last name', 
            maxlength: 'Must be at most 30 characters'
        },
        job_title: {
            required: 'Enter job title', 
            maxlength: 'Must be at most 100 characters'
        },
        phone: {
            required: 'Enter a cell phone number',
            pattern: 'Enter a valid cell phone number'
        },
        email: {
            required: 'Enter a valid email address',
            minlength: 'Must be at least 5 characters',
            maxlength: 'Must be at most 100 characters',
            pattern: 'Enter a valid email address'
        },
        zip: {
            pattern: 'Enter a valid zip code'
        },
    }
};

export const REFERRAL_EMAIL_AUTH_ERR = {
    answer: {
      required: 'Select an option'
    }, 
    fname: USERFORM.validationMessages.fname, 
    lname: USERFORM.validationMessages.lname, 
    email: USERFORM.validationMessages.email,
    org_name: {
      maxlength: 'Must be at most 100 characters'
    }, 
    feedback: {
        required: 'Enter a service description',
        maxlength: 'Must be at most 250 characters',
    }
  };

export const WF_TEST_FORM = {
    fields: {
        phone_no: '',   
    },
    validationMessages: {
        phone_no: {
            required: 'Enter a phone number',
            minlength: '',
            maxlength: '',
            pattern: 'Enter a valid phone number'
        },
    }
};

export const CUSTOM_FIELDS_FORM = {
    fields: {
        field_name: '',
        field_type: '',
        values: ''
    },
    validationMessages: {
        field_name: {
            required: 'Enter minimum 4 alphanumeric characters',
            minlength: 'Enter minimum 4 alphanumeric characters',
            maxlength: 'The characters limit for field name cannot exceed more than 50',
        },
        field_type: {
            required: 'Please select either of the field type',
        },
        values: {
            required: 'Enter minimum one character',
            minlength: 'Enter minimum one character',
            maxlength: 'The characters limit for values cannot exceed more than 50',
            maxLimit: 'You can have maximum of 20 values for a field',
        },
    }
};